import React, { PureComponent, Fragment } from 'react'
import styles from './groups-select.styles'
import injectSheet from 'react-jss'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import Bone from 'pobble-components/dist/bone'

const GroupsOptions = ({ children }) => (
  <Fragment>
    {children.map(({ id, title }) => (
      <option key={id} value={id}>
        {title}
      </option>
    ))}
  </Fragment>
)

class GroupsSelect extends PureComponent {
  componentDidMount() {
    this.props.onMount && this.props.onMount()
  }
  // TO DO - make memorizeable
  applyFilters(groups) {
    const { except, only } = this.props
    return except
      ? groups.filter(group => !except[group.id])
      : only
        ? groups.filter(group => only[group.id])
        : groups
  }
  render() {
    const {
      classes,
      className,
      formSelectProps,
      fetching,
      fetchingError,
      selectOption,
      groupsArray,
      whenNoGroupsAvailable
    } = this.props
    if (fetching) return <Bone className={classes.bone} />
    if (fetchingError)
      return <div className={classes.fetchingError}>Try reload the page</div>
    const options = this.applyFilters(groupsArray)
    if (!options.length && whenNoGroupsAvailable) return whenNoGroupsAvailable
    return (
      <FormSelect className={className} {...formSelectProps}>
        {selectOption && <option value="">{selectOption}</option>}
        <GroupsOptions>{options}</GroupsOptions>
      </FormSelect>
    )
  }
}

export default injectSheet(styles)(GroupsSelect)
